import { useState } from "react";
import { FlaskConical, Compass, Trophy } from "lucide-react";
import TrailDiscoveryPanel from "./TrailDiscoveryPanel";
import TopOpportunityPanel from "./TopOpportunityPanel";
import TrailLabPanel from "./TrailLabPanel";

const TABS = [
  { key: "discover", label: "Discover trails", icon: Compass },
  { key: "opportunity", label: "Top opportunity", icon: Trophy },
  { key: "corridor", label: "Corridor lab", icon: FlaskConical },
];

export default function TrailLab() {
  const [tab, setTab] = useState("discover");
  return (
    <div className="space-y-4" data-testid="trail-lab">
      <div>
        <h2 className="font-heading text-lg font-bold">Trail Lab</h2>
        <p className="text-sm text-muted-foreground">Discover trails from the national repository and save them into Bike Paths, or build territory corridors.</p>
      </div>
      <div className="flex gap-1 rounded-xl border border-border bg-card p-1 w-fit">
        {TABS.map((t) => {
          const Icon = t.icon;
          return (
            <button key={t.key} onClick={() => setTab(t.key)}
              className={`flex items-center gap-2 rounded-lg px-3 py-1.5 text-sm ${tab === t.key ? "bg-primary/15 text-primary" : "text-muted-foreground hover:text-foreground"}`}
              data-testid={`traillab-tab-${t.key}`}>
              <Icon className="w-4 h-4" />{t.label}
            </button>
          );
        })}
      </div>
      {tab === "discover" ? <TrailDiscoveryPanel /> : tab === "opportunity" ? <TopOpportunityPanel /> : <TrailLabPanel />}
    </div>
  );
}
